import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: linear-gradient(
      90deg,
      ${({ theme }) => rgba(theme.borderColor.DEFAULT, 0.6)} 0%,
      ${({ theme }) => theme.borderColor.DEFAULT} 50%,
      ${({ theme }) => rgba(theme.borderColor.DEFAULT, 0.6)} 100%
    ),
    ${({ theme }) => theme.backgroundColor};
`;

const Wrapper = styled.div<{ $flipped?: boolean }>`
  width: 100%;
  transform: ${({ $flipped }) => ($flipped ? 'rotate(180deg)' : 'unset')};
  margin-bottom: 30px;

  ${Divider} {
    &:nth-child(1) {
      margin-bottom: 3px;
    }

    &:nth-child(2) {
      margin-bottom: 4px;
      opacity: 0.9;
    }

    &:nth-child(3) {
      margin-bottom: 5px;
      opacity: 0.8;
    }

    &:nth-child(4) {
      margin-bottom: 6px;
      opacity: 0.7;
    }

    &:nth-child(5) {
      margin-bottom: 7px;
      opacity: 0.6;
    }

    &:nth-child(6) {
      margin-bottom: 8px;
      opacity: 0.5;
    }

    &:nth-child(7) {
      margin-bottom: 9px;
      opacity: 0.4;
    }

    &:nth-child(8) {
      margin-bottom: 10px;
      opacity: 0.3;
    }

    &:nth-child(9) {
      opacity: 0.2;
    }
  }
`;

export interface TronDividerProps {
  className?: string;
  flipped?: boolean;
}

export const TronDivider: React.ComponentType<TronDividerProps> = React.memo(
  ({ className, flipped, ...props }) => {
    return (
      <Wrapper {...props} $flipped={flipped} className={className}>
        <Divider />
        <Divider />
        <Divider />
        <Divider />
        <Divider />
        <Divider />
        <Divider />
        <Divider />
        <Divider />
      </Wrapper>
    );
  }
);
